<div
  class="d-flex flex-wrap gap-2"
  *ngIf="managementView && canManageActiveTiles"
>
  <button
    pButton
    class="my-3"
    type="button"
    (click)="webTileEditor.open()"
  >
    <i class="ri-add-line me-2"></i>Eigene Weblink-Kachel hinzufügen
  </button>
  <a
    pButton
    class="my-3"
    [outlined]="true"
    routerLink="/home"
    [queryParams]="{ standardlayout: 1 }"
  >
    <i class="ri-layout-masonry-line me-2"></i><span i18n="@@tileDefaultLayoutEdit">Standardlayout der Startseite bearbeiten</span>
  </a>
</div>

<app-web-tile-editor
  #webTileEditor
  scope="tenant"
  (saved)="onWebTileSaved()"
></app-web-tile-editor>

@if (!managementView) {
@if (arrangeMode) {
<div
  class="tile-arrange-bar"
  [class.tile-arrange-bar-default]="editingDefaultLayout"
  role="toolbar"
  aria-label="Startseite anpassen"
  i18n-aria-label="@@tileLayoutCustomize"
>
  @if (editingDefaultLayout) {
  <span class="tile-arrange-hint tile-default-hint">
    <i
      class="ri-team-line"
      aria-hidden="true"
    ></i>
    <span i18n="@@tileDefaultLayoutHint"><strong>Standardlayout für alle Nutzer von {{ currentMandantName }}</strong> — gilt für neue Nutzer und für „Standard wiederherstellen“. Zur Auswahl stehen nur Kacheln, die alle sehen.</span>
  </span>
  } @else {
  <span
    class="tile-arrange-hint"
    i18n="@@tileLayoutHint"
  >Ziehen zum Verschieben, Größe unten auf der Kachel wählen, mit − entfernen.</span>
  }
  <div class="tile-arrange-actions">
    @if (editingDefaultLayout) {
    <button
      pButton
      type="button"
      [outlined]="true"
      (click)="addSeparator()"
    >
      <i class="ri-separator me-2"></i><span i18n="@@tileSeparatorAdd">Separator hinzufügen</span>
    </button>
    } @else {
    <button
      pButton
      type="button"
      [outlined]="true"
      (click)="widgetDialog.open()"
    >
      <i class="ri-add-line me-2"></i><span i18n="@@tileLayoutAddWidget">Hinzufügen</span>
    </button>
    }
    @if (hiddenTiles.length) {
    <button
      pButton
      type="button"
      [outlined]="true"
      (click)="addTilesDialogVisible = true"
    >
      <i class="ri-eye-off-line me-2"></i><span i18n="@@tileLayoutAddTiles">Gerade ausgeblendet ({{ hiddenTiles.length }})</span>
    </button>
    }
    <button
      pButton
      type="button"
      [text]="true"
      severity="secondary"
      [disabled]="!canResetLayout"
      (click)="requestResetLayout()"
    >
      @if (editingDefaultLayout) {
      <span i18n="@@tileDefaultLayoutReset">Standardlayout zurücksetzen</span>
      } @else {
      <span i18n="@@tileLayoutReset">Standard wiederherstellen</span>
      }
    </button>
    @if (!editingDefaultLayout && canManageActiveTiles) {
    <button
      pButton
      type="button"
      [text]="true"
      (click)="startEditingDefaultLayout()"
    >
      <i class="ri-team-line me-2"></i><span i18n="@@tileDefaultLayoutEditShort">Standardlayout bearbeiten</span>
    </button>
    }
    <button
      pButton
      type="button"
      (click)="stopArranging()"
    >
      @if (editingDefaultLayout) {
      <span i18n="@@tileDefaultLayoutDone">Fertig, zurück zu meiner Startseite</span>
      } @else {
      <span i18n="@@tileLayoutDone">Fertig</span>
      }
    </button>
  </div>
</div>
}
}

<app-web-tile-editor
  #personalTileEditor
  scope="personal"
  (saved)="onPersonalTileSaved()"
></app-web-tile-editor>

<app-home-widget-dialog
  #widgetDialog
  (chooseLink)="personalTileEditor.open()"
  (chooseSeparator)="addSeparator()"
  (saved)="onPersonalTileSaved()"
></app-home-widget-dialog>

@if (managementView && canManageActiveTiles) {
<p-card>
  <p-table
    [value]="managedTiles"
    dataKey="_id"
    [paginator]="managedTiles.length > 10"
    [rows]="10"
    styleClass="p-datatable-sm"
    [tableStyle]="{'min-width': '42rem'}"
  >
    <ng-template #header>
      <tr>
        <th pSortableColumn="name"><span i18n="@@globalName">Name</span><p-sorticon field="name"></p-sorticon></th>
        <th i18n="@@companyAppsSource">Herkunft</th>
        <th i18n="@@companyAppsSharing">Freigabe</th>
        <th
          class="text-end"
          i18n="@@companyAppsActions"
        >Aktionen</th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-tile
    >
      <tr>
        <td>
          <div class="d-flex align-items-center gap-2">
            <app-tile-icon [tile]="tile" [inline]="true"></app-tile-icon>
            <div class="text-break">
              <span>{{ tile.name }}</span>
              @if (tile.subtext) { <div class="text-muted small">{{ tile.subtext }}</div> }
            </div>
          </div>
        </td>
        <td>
          @if (tile.ownerMandantId) { <span i18n="@@companyAppsOwnLink">Eigener Weblink</span> }
          @else { <span i18n="@@companyAppsPool">Kachel-Pool</span> }
        </td>
        <td>
          <p-tag
            class="sharing-tag"
            [severity]="getSharingSeverity(tile)"
            [value]="getSharingLabel(tile)"
          ></p-tag>
        </td>
        <td class="text-end">
          <div class="tile-table-actions">
            @if (tile.ownerMandantId) {
            <button
              pButton
              type="button"
              [text]="true"
              class="tile-table-action"
              title="Weblink bearbeiten"
              [attr.aria-label]="'Weblink bearbeiten: ' + tile.name"
              (click)="editOwnWebTile(tile)"
            >
              <i
                class="ri-edit-line"
                aria-hidden="true"
              ></i>
            </button>
            }
            <button
              pButton
              type="button"
              [text]="true"
              class="tile-table-action"
              title="Freigabe bearbeiten"
              [attr.aria-label]="'Freigabe bearbeiten: ' + tile.name"
              (click)="openTileSharingDialog(tile)"
            >
              <i
                class="ri-user-shared-line"
                aria-hidden="true"
              ></i>
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td
          colspan="4"
          class="text-center text-muted py-4"
          i18n="@@companyAppsEmpty"
        >Noch keine Apps oder Links vorhanden.</td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
}

@if (!managementView) {
@if (!arrangeMode) {
<div class="tile-search-toolbar">
  <div class="tile-search-field">
    <i
      class="ri-search-line"
      aria-hidden="true"
    ></i>
    <input
      #tileSearchInput
      pInputText
      type="search"
      [(ngModel)]="tileSearch"
      (keydown.escape)="tileSearch = ''"
      placeholder="Apps und Links suchen"
      i18n-placeholder="@@portalTileSearch"
      aria-label="Apps und Links suchen"
      i18n-aria-label="@@portalTileSearch"
    >
    @if (tileSearch) {
    <button
      pButton
      type="button"
      [text]="true"
      aria-label="Suche zurücksetzen"
      i18n-aria-label="@@portalTileSearchClear"
      pTooltip="Suche zurücksetzen"
      i18n-pTooltip="@@portalTileSearchClear"
      (click)="tileSearch = ''; tileSearchInput.focus()"
    ><i
        class="ri-close-line"
        aria-hidden="true"
      ></i></button>
    }
  </div>
  <span
    class="tile-search-count"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    <ng-container i18n="@@portalTileSearchCount">{{ filteredTileCount }} von {{ totalTileCount }}</ng-container>
  </span>
  <button
    pButton
    class="tile-customize-button"
    type="button"
    [text]="true"
    pTooltip="Tipp: Eine Kachel lange gedrückt halten"
    i18n-pTooltip="@@tileLayoutCustomizeTip"
    (click)="startArranging()"
  >
    <i class="ri-layout-masonry-line me-2"></i><span i18n="@@tileLayoutCustomize">Startseite anpassen</span>
  </button>
</div>
}
<span
  class="visually-hidden"
  role="status"
  aria-live="polite"
  aria-atomic="true"
>{{ layoutStatus }}</span>
@if (tileSearch.trim() && filteredTileCount === 0) {
<p
  class="tile-search-empty"
  i18n="@@portalTileSearchEmpty"
>Keine passenden Apps oder Links gefunden.</p>
}
@if (!tileSearch.trim() && totalTileCount > 0 && filteredTileCount === 0) {
<p
  class="tile-search-empty"
  i18n="@@tileLayoutAllHidden"
>Alle Kacheln sind ausgeblendet. Über „Startseite anpassen“ holst du sie zurück.</p>
}
<div class="tile-grid-frame">
  <div
    #tileGrid
    class="tile-grid"
    [class.tile-grid-arranging]="arrangeMode"
    cdkDropList
    cdkDropListOrientation="mixed"
    [cdkDropListDisabled]="!arrangeMode"
    [cdkDropListSortPredicate]="tileSortPredicate"
    (cdkDropListSorted)="animateTileShift(tileGrid)"
    (cdkDropListDropped)="onTileDrop($event)"
  >
    @for (tile of filteredTiles; track tile._id; let odd = $odd) {
    <div
      class="tile-wrapper"
      [ngClass]="tile.separator ? 'tile-separator-wrapper' : 'tile-size-' + tileSize(tile)"
      [class.tile-wiggle-alt]="odd"
      cdkDrag
      [cdkDragData]="tile"
      (cdkDragStarted)="startTileDrag(tileGrid)"
      (cdkDragEnded)="endTileDrag()"
      (pointerdown)="onTilePointerDown($event)"
      (pointermove)="onTilePointerMove($event)"
      (pointerup)="cancelLongPress()"
      (pointercancel)="cancelLongPress()"
      (pointerleave)="cancelLongPress()"
      (contextmenu)="arrangeMode && $event.preventDefault()"
    >
      @if (tile.separator) {
      @if (arrangeMode) {
      <div class="tile-separator tile-separator-editing">
        <i
          class="ri-draggable tile-separator-grip"
          aria-hidden="true"
        ></i>
        <input
          #separatorTitle
          pInputText
          type="text"
          class="tile-separator-input"
          [id]="separatorInputId(tile)"
          [value]="tile.name"
          [attr.maxlength]="maxSeparatorTitleLength"
          [attr.aria-label]="'Titel des Separators: ' + tile.name"
          (mousedown)="$event.stopPropagation()"
          (touchstart)="$event.stopPropagation()"
          (pointerdown)="$event.stopPropagation()"
          (keydown.enter)="separatorTitle.blur()"
          (keydown.escape)="$event.stopPropagation(); separatorTitle.value = tile.name; separatorTitle.blur()"
          (blur)="renameSeparator(tile, separatorTitle.value)"
        >
        <button
          type="button"
          class="tile-separator-remove"
          pTooltip="Separator entfernen"
          i18n-pTooltip="@@tileSeparatorRemove"
          [attr.aria-label]="'Separator entfernen: ' + tile.name"
          (pointerdown)="$event.stopPropagation()"
          (click)="removeSeparator(tile)"
        ><i
            class="ri-subtract-line"
            aria-hidden="true"
          ></i></button>
      </div>
      } @else {
      <h3 class="tile-separator">
        <span class="tile-separator-title">{{ tile.name }}</span>
      </h3>
      }
      } @else {
      @if (arrangeMode) {
      <button
        type="button"
        class="tile-remove-btn"
        pTooltip="Von der Startseite entfernen"
        i18n-pTooltip="@@tileLayoutRemove"
        [attr.aria-label]="'Von der Startseite entfernen: ' + tile.name"
        (pointerdown)="$event.stopPropagation()"
        (click)="hideTile(tile)"
      ><i
          class="ri-subtract-line"
          aria-hidden="true"
        ></i></button>
      <div
        class="tile-arrange-controls"
        role="group"
        [attr.aria-label]="tile.name"
        (pointerdown)="$event.stopPropagation()"
      >
        @for (option of tileSizeOptions; track option.size) {
        <button
          type="button"
          class="tile-size-btn"
          [class.active]="tileSize(tile) === option.size"
          [attr.aria-pressed]="tileSize(tile) === option.size"
          [pTooltip]="option.label"
          [attr.aria-label]="option.label + ': ' + tile.name"
          (click)="setTileSize(tile, option.size)"
        ><span
            class="tile-size-glyph"
            [ngClass]="'tile-size-glyph-' + option.size"
            aria-hidden="true"
          ></span></button>
        }
      </div>
      } @else {
      <button
        *ngIf="tile.personal"
        pButton
        type="button"
        [text]="true"
        class="tile-manage-btn"
        [title]="tile.widget ? 'Kachel bearbeiten' : 'Privaten Link bearbeiten'"
        [attr.aria-label]="(tile.widget ? 'Kachel bearbeiten: ' : 'Privaten Link bearbeiten: ') + tile.name"
        (pointerdown)="$event.stopPropagation()"
        (click)="$event.preventDefault(); $event.stopPropagation(); tile.widget ? widgetDialog.open(tile) : personalTileEditor.open(tile)"
      ><i
          class="ri-more-2-fill"
          aria-hidden="true"
        ></i></button>
      }
      @if (tile.widget) {
      <div
        class="tile-link tile-widget"
        [attr.aria-hidden]="arrangeMode ? true : null"
      >
        @switch (tile.widget.type) {
        @case ('note') { <app-note-tile [tile]="tile" [readonly]="arrangeMode"></app-note-tile> }
        @case ('clock') { <app-clock-tile [tile]="tile"></app-clock-tile> }
        @case ('weather') { <app-weather-tile [tile]="tile"></app-weather-tile> }
        }
      </div>
      } @else {
      <a
        [href]="getTileUrl(tile.url, tile.kind)"
        (click)="onTileClick($event, tile)"
        (auxclick)="recordTileOpen($event, tile)"
        [attr.tabindex]="arrangeMode ? -1 : null"
        [attr.aria-hidden]="arrangeMode ? true : null"
        rel="noopener noreferrer"
        target="{{tile.openInNewTab ? '_blank' : '_self'}}"
        class="tile-link tile-link-compact text-decoration-none"
        draggable="false"
      >
        <app-tile-preview
          [tile]="tile"
          [mandantName]="currentMandantName"
          variant="compact"
        ></app-tile-preview>
      </a>
      }
      }
      <div
        *cdkDragPlaceholder
        class="tile-drop-placeholder"
        [ngClass]="tile.separator ? 'tile-separator-wrapper' : 'tile-size-' + tileSize(tile)"
      ></div>
    </div>
    }
  </div>
</div>

<p-dialog
  [(visible)]="resetConfirmVisible"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{width: 'min(440px, 95vw)'}"
>
  <ng-template #header>
    @if (editingDefaultLayout) {
    <span class="fs-6 fw-bold" i18n="@@tileDefaultLayoutResetHeader">Standardlayout zurücksetzen?</span>
    } @else {
    <span class="fs-6 fw-bold" i18n="@@tileLayoutResetHeader">Standard wiederherstellen?</span>
    }
  </ng-template>
  @if (editingDefaultLayout) {
  <p class="mb-0" i18n="@@tileDefaultLayoutResetText">Das Standardlayout von {{ currentMandantName }} wird gelöscht. Nutzer ohne eigene Anordnung sehen danach alle Kacheln in der eingebauten Reihenfolge.</p>
  } @else {
  <p class="mb-0" i18n="@@tileLayoutResetText">Deine Anordnung wird durch das Standardlayout ersetzt. Deine eigenen Kacheln (Links, Notizen, Uhren, Wetter) bleiben erhalten – sie erscheinen unter „Zusätzliche Kacheln – nur für dich“.</p>
  }
  <ng-template #footer>
    <button
      pButton
      type="button"
      [text]="true"
      severity="secondary"
      (click)="resetConfirmVisible = false"
      i18n="@@tileLayoutResetCancel"
    >Abbrechen</button>
    <button
      pButton
      type="button"
      (click)="confirmResetLayout()"
    >
      @if (editingDefaultLayout) {
      <span i18n="@@tileDefaultLayoutResetConfirm">Zurücksetzen</span>
      } @else {
      <span i18n="@@tileLayoutResetConfirm">Wiederherstellen</span>
      }
    </button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="addTilesDialogVisible"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{width: 'min(480px, 95vw)'}"
>
  <ng-template #header>
    <span
      class="fs-6 fw-bold"
      i18n="@@tileLayoutAddTilesHeader"
    >Gerade ausgeblendet</span>
  </ng-template>
  <ul class="tile-add-list">
    @for (tile of hiddenTiles; track tile._id) {
    <li>
      <app-tile-icon
        [tile]="tile"
        [inline]="true"
      ></app-tile-icon>
      <span class="tile-add-name">{{ tile.name || tile.text }}</span>
      <button
        pButton
        type="button"
        [text]="true"
        class="tile-add-btn"
        [attr.aria-label]="'Hinzufügen: ' + tile.name"
        (click)="showTile(tile)"
      ><i
          class="ri-add-circle-fill"
          aria-hidden="true"
        ></i></button>
    </li>
    }
  </ul>
</p-dialog>
}

<div
  class="tile-debug-list"
  *ngIf="debugMode"
>
  <div
    class="tile-debug-title"
    i18n="@@tileDebugTitle"
  >Sichtbarkeitsgründe</div>
  <div
    *ngFor="let entry of debugEntries"
    class="tile-debug-entry"
    [class.tile-debug-entry--hidden]="!entry.visible"
  >
    <strong>{{ entry.tile.name }}</strong>
    <span
      class="tile-debug-status"
      i18n="@@tileDebugStatusVisible"
      *ngIf="entry.visible"
    >sichtbar</span>
    <span
      class="tile-debug-status"
      i18n="@@tileDebugStatusHidden"
      *ngIf="!entry.visible"
    >ausgeblendet</span>
    <ul>
      <li *ngFor="let label of getVisibilityReasonLabels(entry.reasons)">{{ label }}</li>
      <li
        *ngIf="entry.missingPermissions.length > 0"
        i18n="@@tileDebugMissingPermissions"
      >Fehlende Berechtigung(en): {{ entry.missingPermissions.join(', ') }}</li>
    </ul>
  </div>
</div>

<p-dialog
  [(visible)]="mandantTilesDialogVisible"
  [modal]="true"
  [style]="{width: 'min(720px, 95vw)'}"
  [dismissableMask]="true"
>
  <ng-template #header>
    <span
      class="fs-6 fw-bold"
      i18n="@@portalManageMandantTilesHeader"
    >Kachel-Pool für {{currentMandantName}}</span>
  </ng-template>

  <p
    *ngIf="availableTiles.length === 0"
    class="text-muted small"
    i18n="@@portalManageMandantTilesEmptyPool"
  >Der Kachel-Pool dieses Mandanten ist leer.</p>
  <div
    *ngFor="let tile of availableTiles"
    class="tile-visibility-row mb-3"
  >
    <div class="d-flex justify-content-between align-items-center mb-2 gap-2">
      <span class="d-flex align-items-center gap-2 tile-visibility-name">
        <span
          class="tile-admin-table-icon-badge"
          [ngStyle]="{'background-color': tile.color ?? '#6366f1'}"
        >
          <app-tile-icon [tile]="tile"></app-tile-icon>
        </span>
        <span class="fw-semibold text-truncate">{{ tile.name }}</span>
      </span>
      <div class="d-flex align-items-center gap-2 tile-visibility-control">
        <label
          class="text-muted small mb-0"
          i18n="@@portalManageMandantTilesVisibilityLabel"
        >Sichtbarkeit</label>
        <p-select
          [options]="tileVisibilityOptions"
          optionLabel="label"
          optionValue="value"
          [ngModel]="tileVisibilityMode[tile._id]"
          (onChange)="setTileVisibilityMode(tile._id, $event.value)"
          styleClass="tile-visibility-select"
          appendTo="body"
        ></p-select>
      </div>
    </div>
    <p-picklist
      *ngIf="tileVisibilityMode[tile._id] === 'selected'"
      [source]="tileSourceUsers[tile._id]"
      [target]="tileTargetUsers[tile._id]"
      (targetChange)="setTileTargetUsers(tile._id, $event)"
      dataKey="id"
      [showSourceControls]="false"
      [showTargetControls]="false"
      [responsive]="true"
    >
      <ng-template
        #item
        let-user
      >{{ user.name }}</ng-template>
    </p-picklist>
  </div>

  <ng-template #footer>
    <button
      pButton
      type="button"
      severity="secondary"
      [outlined]="true"
      (click)="mandantTilesDialogVisible = false"
      i18n="@@cancel"
    >Abbrechen</button>
    <button
      pButton
      type="button"
      [loading]="savingMandantTiles"
      (click)="saveMandantTiles()"
      i18n="@@globalSave"
    >Speichern</button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="tileSharingDialogVisible"
  [modal]="true"
  [style]="{width: 'min(720px, 95vw)'}"
  [dismissableMask]="true"
>
  <ng-template #header>
    <span class="d-flex align-items-center gap-2">
      <span
        *ngIf="sharingTile"
        class="tile-admin-table-icon-badge"
        [ngStyle]="{'background-color': sharingTile.color ?? '#6366f1'}"
      >
        <app-tile-icon [tile]="sharingTile"></app-tile-icon>
      </span>
      <span
        class="fs-6 fw-bold"
        i18n="@@portalManageTileSharingHeader"
      >Freigabe aus dem Kachel-Pool: {{sharingTile?.name}}</span>
    </span>
  </ng-template>

  <div
    *ngIf="sharingTile"
    class="tile-visibility-row mb-3"
  >
    <div class="d-flex justify-content-end align-items-center gap-2 mb-2">
      <label
        class="text-muted small mb-0"
        i18n="@@portalManageMandantTilesVisibilityLabel"
      >Sichtbarkeit</label>
      <p-select
        [options]="tileVisibilityOptions"
        optionLabel="label"
        optionValue="value"
        [ngModel]="tileVisibilityMode[sharingTile._id]"
        (onChange)="setTileVisibilityMode(sharingTile._id, $event.value)"
        styleClass="tile-visibility-select"
        appendTo="body"
      ></p-select>
    </div>
    <p-picklist
      *ngIf="tileVisibilityMode[sharingTile._id] === 'selected'"
      [source]="tileSourceUsers[sharingTile._id]"
      [target]="tileTargetUsers[sharingTile._id]"
      (targetChange)="setTileTargetUsers(sharingTile._id, $event)"
      dataKey="id"
      [showSourceControls]="false"
      [showTargetControls]="false"
      [responsive]="true"
    >
      <ng-template
        #item
        let-user
      >{{ user.name }}</ng-template>
    </p-picklist>
  </div>

  <ng-template #footer>
    <button
      pButton
      type="button"
      severity="secondary"
      [outlined]="true"
      (click)="tileSharingDialogVisible = false"
      i18n="@@cancel"
    >Abbrechen</button>
    <button
      pButton
      type="button"
      [loading]="savingMandantTiles"
      (click)="saveMandantTiles()"
      i18n="@@globalSave"
    >Speichern</button>
  </ng-template>
</p-dialog>